import { useMemo } from "react";
import { IOption } from "components/MainSelect/MainSelectInterfaces";
import { useTranslation } from "react-i18next";
import { IRCAAPComplianceByResponsibleFilter } from "./RCAAPComplianceByResponsibleFilterInterfaces";

const useRCAAPComplianceByResponsibleFilter = ({
    rcaApComplianceByResponsibleOptions,
}: IRCAAPComplianceByResponsibleFilter) => {
    const { t } = useTranslation();

    const optionNames = useMemo(() => {
        return [
            "rca.compliance.filters.type.alphabetically_asc",
            "rca.compliance.filters.type.alphabetically_desc",
            "rca.compliance.filters.type.compliance_low_to_high",
            "rca.compliance.filters.type.compliance_high_to_low",
        ];
    }, []);

    const rcaComplianceByResponsibleOptions: IOption[] = useMemo(
        () =>
            rcaApComplianceByResponsibleOptions.map((value, index) => ({
                id: value,
                name: t(optionNames[index]),
            })),
        [t, rcaApComplianceByResponsibleOptions, optionNames],
    );

    return {
        rcaComplianceByResponsibleOptions,
    };
};

export default useRCAAPComplianceByResponsibleFilter;
